// 统计信息只放在请求头中，不参与业务签名、加密或上传参数。
const prefix = 'X-MC-Quality-';
const pollPath = /\/(?:progress|get_progress|uploadProg|uploadProgress|downloadProgress|auth_progress)\/?$/i;
let navigation = null;

function id() {
    const bytes = new Uint8Array(16);
    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(bytes);
    } else {
        for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    return Array.from(bytes, value => ('0' + value.toString(16)).slice(-2)).join('');
}

function matches(url, base, relativeTo) {
    if (!base) return false;
    const api = new URL(base, relativeTo);
    const path = api.pathname.replace(/\/+$/, '');
    return url.origin === api.origin && (url.pathname === path || url.pathname.indexOf(path + '/') === 0);
}

export default {
    manual() { return { trigger: 'MANUAL', actionId: id() }; },
    system() { return { trigger: 'SYSTEM' }; },
    request(context) { return Object.assign({}, context, { requestId: id(), retry: 0 }); },
    config(context, config = {}) {
        const result = Object.assign({}, config, { headers: Object.assign({}, config.headers) });
        if (context) {
            if (context.trigger) result.headers[prefix + 'Trigger'] = context.trigger;
            if (context.actionId) result.headers[prefix + 'Action'] = context.actionId;
            if (context.requestId) result.headers[prefix + 'Request'] = context.requestId;
            if (context.retry !== undefined) result.headers[prefix + 'Retry'] = String(context.retry);
        }
        return result;
    },
    markNavigation(key, currentKey) { navigation = key === currentKey ? null : { key, context: this.manual() }; },
    takeNavigation(key) {
        if (navigation && navigation.key === key) {
            const context = navigation.context;
            navigation = null;
            return context;
        }
        return this.system();
    },
    // 一个按钮触发多个请求时，共用 manual() 返回的上下文；每个请求仍有独立身份。
    install(axios, getBases) {
        return axios.interceptors.request.use(config => {
            try {
                const location = window.location.href;
                let address = config.url || '';
                if (config.baseURL && !/^(?:[a-z][a-z\d+.-]*:)?\/\//i.test(address)) {
                    address = config.baseURL.replace(/\/+$/, '') + '/' + address.replace(/^\/+/, '');
                }
                const url = new URL(address, location);
                const bases = getBases();
                const mc = [bases.apiUrl, bases.uploadUrl, bases.previewApiwUrl,
                    bases.sharePageApiUrl && bases.sharePageApiUrl.replace(/\/+$/, '') + '/api',
                    bases.liteUrl && bases.liteUrl.replace(/\/+$/, '') + '/lite']
                    .some(base => matches(url, base, location));
                const headers = config.headers || (config.headers = {});
                if (!mc) {
                    Object.keys(headers).forEach(key => {
                        if (key.toLowerCase().indexOf(prefix.toLowerCase()) === 0) delete headers[key];
                    });
                    return config;
                }
                headers[prefix + 'Client'] = 'WEB';
                headers[prefix + 'Request'] = headers[prefix + 'Request'] || id();
                headers[prefix + 'Action'] = headers[prefix + 'Action'] || id();
                headers[prefix + 'Retry'] = headers[prefix + 'Retry'] || '0';
                // 轮询始终是系统行为；未标记的读取由后端保持 UNKNOWN。
                if (pollPath.test(url.pathname)) headers[prefix + 'Trigger'] = 'SYSTEM';
            } catch (ignored) {
                // 统计辅助逻辑失败时，仍正常发送原请求。
            }
            return config;
        });
    },
    retry(axios, error) {
        const config = error.config;
        if (!config || axios.isCancel(error)) return Promise.reject(error);
        const headers = config.headers || {};
        const mc = !!headers[prefix + 'Request'];
        // Axios 0.19 会丢弃 retry、__retryCount 等自定义配置；MC 请求用已保留的请求头传递次数。
        const limit = config.retry === undefined ? (mc ? axios.defaults.retry : 0) : config.retry;
        const count = mc ? Number(headers[prefix + 'Retry'] || 0) : config.__retryCount || 0;
        if (!limit || count >= limit) return Promise.reject(error);
        config.__retryCount = count + 1;
        if (mc) headers[prefix + 'Retry'] = String(count + 1);
        const delay = config.retryDelay === undefined ? axios.defaults.retryDelay : config.retryDelay;
        return new Promise(resolve => setTimeout(resolve, delay || 1)).then(() => axios(config));
    }
};



// WEBPACK FOOTER //
// ./src/js/quality_util.js